import LayerProps from './LayerProps'

export default {
    name: 'kendo-map-layer',
    render () {
        return null
    },
    mixins: [LayerProps]
}


// WEBPACK FOOTER //
// ./packages/kendo-map-vue-wrapper/src/KendoMapLayer/index.js